import {
  FirmIndexes,
  FirmWithAutoFillColors,
} from '@/shared/constants/brushMapFirms'
import { BrushToothImages } from '@/shared/constants/brushToothImages'
import {
  ArrowStatusType,
  BrushToothImageType,
  HEXcolor,
  StatusToothType,
} from '@/shared/types'

export type ToothForSend = {
  isBleeding: boolean
  isDentalFloss: boolean
  baseColor: HEXcolor
  arrowColor: [HEXcolor, HEXcolor]
  arrowStatus: ArrowStatusType
  statusTooth: StatusToothType
  id: number
}

type ArrowClass = `arrow${number}`
type NumberClass = `number${number}`
type ToothClass = `tooth${number}`

export class Tooth {
  public readonly arrowClass: ArrowClass
  public readonly numberClass: NumberClass
  public readonly toothClass: ToothClass
  public baseColor: HEXcolor
  public isBleeding: boolean
  public isDentalFloss: boolean
  public arrowColor: [HEXcolor, HEXcolor]
  public arrowStatus: ArrowStatusType
  public readonly DEFAULT_COLOR: HEXcolor
  public statusTooth: StatusToothType
  public readonly widthImage: number
  public readonly heightImage: number
  public readonly id: number
  private readonly img: BrushToothImageType

  constructor(
    id: number,
    index: number,
    baseColor: HEXcolor = '#b3b3b3',
    arrowStatus: ArrowStatusType = 0,
    arrowColor: [HEXcolor, HEXcolor] = ['#b3b3b3', '#b3b3b3'],
    statusTooth: StatusToothType = 'Normal',
    isDentalFloss = false,
    isBleeding = false
  ) {
    this.DEFAULT_COLOR = '#b3b3b3'
    this.id = id
    this.statusTooth = statusTooth
    this.arrowStatus = arrowStatus
    this.baseColor = baseColor
    this.arrowColor = arrowColor
    this.img = BrushToothImages[index]
    this.widthImage = this.img.width
    this.isDentalFloss = isDentalFloss
    this.isBleeding = isBleeding
    this.heightImage = this.img.height
    if (id !== 41 && id !== 11) {
      this.arrowClass = `arrow${id}`
    }
    this.numberClass = `number${id}`
    this.toothClass = `tooth${id}`
  }

  public getTeethForSend(): ToothForSend {
    return {
      isBleeding: this.isBleeding,
      isDentalFloss: this.isDentalFloss,
      arrowStatus: this.arrowStatus,
      arrowColor: this.arrowColor,
      baseColor: this.baseColor,
      statusTooth: this.statusTooth,
      id: this.id,
    }
  }

  public getImageTooth(): string {
    return this.img[this.statusTooth.toLowerCase()]
  }

  public updateStatusTooth(): void {
    switch (this.statusTooth) {
      case 'Normal':
        this.statusTooth = 'Implant'
        break
      case 'Implant':
        this.statusTooth = 'Empty'
        break
      case 'Empty':
        this.statusTooth = 'Normal'
    }
  }

  public updateArrowStatus(): void {
    if (this.arrowStatus > 2) {
      this.arrowStatus = 0
    } else {
      this.arrowStatus++
    }
  }

  public clearArrowColors(): void {
    this.arrowStatus = 0
    this.arrowColor = [this.DEFAULT_COLOR, this.DEFAULT_COLOR]
    this.baseColor = this.DEFAULT_COLOR
  }

  public updateColorWithFirm(
    firm: FirmWithAutoFillColors,
    indexNewFirm: FirmIndexes
  ): void {
    if (this.baseColor === this.DEFAULT_COLOR) {
      return
    }

    const autoFillColorVariants = firm.content[this.baseColor]
    console.log(firm.content)
    console.log(this.baseColor)
    if (!autoFillColorVariants) {
      return this.updateArrowColor(this.DEFAULT_COLOR)
    }

    const autoFillColor = autoFillColorVariants[indexNewFirm]

    this.updateArrowColor(autoFillColor)
  }

  public updateArrowColor(newColor: HEXcolor): void {
    const status = this.arrowStatus

    switch (status) {
      case 0:
        this.clearArrowColors()
        break
      case 1:
        this.arrowColor = [this.DEFAULT_COLOR, newColor]
        this.baseColor = newColor
        break
      case 2:
        this.arrowColor = [newColor, this.DEFAULT_COLOR]
        this.baseColor = newColor
        break
      case 3:
        this.arrowColor = [newColor, newColor]
        this.baseColor = newColor
        break
    }
  }
}
